module.exports = __webpack_public_path__ + "feeafbd69456f7e0fdb2d4daba7bd837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-no-problem.png
// module id = 2067
// module chunks = 4